<template>
	<div v-on="$listeners" class="c-card-qa-item" :class="{ 'c-card-qa-item--border': border }">
		<div class="c-card-question-panel">
			<m-svg-icon name="question" class="c-question-prefix" />
			<div class="c-question-value">{{ item.question }}</div>
		</div>
		<div class="c-card-answer-panel">
			<div class="c-answer-block">
				<span :class="{ 'c-answer--ellipsis': ellipsis }">{{ item.answer }}</span>
			</div>
			<div class="c-answer-date">{{ formatRowData(item) }}</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import { EN } from '@/assets/js/i18n';

export default {
	props: {
		item: {
			type: Object,
			default: () => {
				return {};
			}
		},
		border: {
			type: Boolean,
			default: true
		},
		ellipsis: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			CODE_FILTER_NAME: {
				5: this.$t('enterprise.QA.tab.enquiry'),
				1: this.$t('enterprise.QA.tab.meeting'),
				4: this.$t('enterprise.QA.tab.activities')
			}
		};
	},
	computed: {
		...mapGetters(['getIrBaseInfo', 'getIrFullCode']),
		formatAnswerDate() {
			if (!this.item.answerDate) return '';
			return this.item.answerDate.slice(0, -3);
		},
		source() {
			let market = this.getIrFullCode?.slice(0, 2);
			market = market && market.toLocaleUpperCase();
			if (market === 'SH') {
				this.CODE_FILTER_NAME[3] = 'e互动';
			}
			if (market === 'SZ') {
				this.CODE_FILTER_NAME[3] = '互动易';
			}
			return this.CODE_FILTER_NAME;
		}
	},
	methods: {
		formatRowData(item) {
			let activeTab = this.$parent.$parent.activeTab;
			let preTmpl =
				typeof item.sourceBiz == 'undefined'
					? ''
					: `${this.$t('enterprise.from-leave-message')} ：${this.source[item.sourceBiz]} ｜ `;

			return `${activeTab == 0 ? preTmpl : ''}${this.$i18n.locale == EN ? '' : item.orgName} ${
				item.sourceBiz == 4
					? `${this.$t('enterprise.disclose-to-message')}`
					: `${this.$t('enterprise.answer-to-message')}`
			}${item.answerTime || item.questionTime || '-'}`;
		}
	}
};
</script>

<style lang="less" scoped>
@import '../../../style/mixins';

.c-card-qa-item {
	padding-bottom: 0.14rem;

	&--border {
		.thinner-border-bottom(#e8eaef);
	}
	& + .c-card-qa-item {
		margin-top: 0.12rem;
	}

	.c-card-question-panel {
		display: flex;

		.c-question-prefix {
			margin-top: 0.04rem;
			font-size: 0.16rem;
			color: var(--ir-theme-color);
		}
		.c-question-value {
			margin-left: 0.08rem;
			flex: 1;
			width: 0;
			color: #333;

			/* 15/H5-medium */
			font-family: 'PingFang SC';
			font-size: 0.15rem;
			font-style: normal;
			font-weight: 500;
			line-height: 140%; /* 21px */
		}
	}

	.c-card-answer-panel {
		margin-top: 0.08rem;

		.c-answer-block {
			padding: 0.1rem;
			border-radius: 0.04rem;
			background: #f7f8fa;

			span {
				color: #666;

				/* 14/H6-regular */
				font-family: 'PingFang SC';
				font-size: 0.14rem;
				font-style: normal;
				font-weight: 400;
				line-height: 140%; /* 19.6px */
			}
		}
		.c-answer--ellipsis {
			.text-overflow-multi-row(2);
		}
		.c-answer-date {
			margin-top: 0.08rem;
			color: #c5c5c5;
			text-align: left;
			font-family: 'PingFang SC';
			font-size: 0.11rem;
			font-style: normal;
			font-weight: 400;
			line-height: 0.15rem; /* 136.364% */
		}
	}
}
</style>
